// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { AuditReturnOrderProperty } from '@/audit/api/types';
import { AuditPropertyValue } from '@/audit/components/audit-property-value';
import { Link } from '@/components/link';
import { ArrowForwardRounded } from '@/constants/hardfin-standard-icons';
import { Typography } from '@mui/material';

interface Props {
  property: AuditReturnOrderProperty;
}

interface ReturnOrderValue {
  key: string;
  roNumber: string;
}

/**
 * Renders a return order reference as a link to its detail page. A null
 * reference (the order was cleared) renders as the usual empty value.
 */
function ReturnOrderValueLabel(props: {
  value: ReturnOrderValue | null | undefined;
}) {
  if (!props.value) {
    return <AuditPropertyValue value={null} />;
  }

  return (
    <Link
      to="/return-orders/$returnOrderKey"
      params={{ returnOrderKey: props.value.key }}
      variant="inherit"
    >
      {props.value.roNumber}
    </Link>
  );
}

export function AuditReturnOrderLabel(props: Props) {
  if (props.property.oldValue === undefined) {
    return (
      <Typography display="flex" variant="caption" alignItems="center">
        <Typography component="span" variant="inherit" fontWeight="bold">
          {props.property.name}:&nbsp;
        </Typography>
        <ReturnOrderValueLabel value={props.property.newValue} />
      </Typography>
    );
  }

  return (
    <Typography display="flex" variant="caption" alignItems="center">
      <Typography component="span" variant="inherit" fontWeight="bold">
        {props.property.name}:&nbsp;
      </Typography>
      <ReturnOrderValueLabel value={props.property.oldValue} />
      <ArrowForwardRounded fontSize="inherit" sx={{ marginX: 1 }} />
      <ReturnOrderValueLabel value={props.property.newValue} />
    </Typography>
  );
}
